export const invoiceProjectGetters = {
  invoiceProjects: (state) => state.invoiceProjects,
  invoiceProjectDetails: (state) => state.invoiceProjectDetails,
}
